/**
 * Saving Life Slider — frontend view script.
 * 1. Replaces legacy "$" currency with "₹" in amount spans.
 * 2. Makes Medical Report images clickable — opens image URL in current tab.
 */
document.addEventListener( "DOMContentLoaded", function () {

	/* ── 1. Currency symbol fix ── */
	document.querySelectorAll( ".saving-life-amount-value" ).forEach( function ( el ) {
		if ( el.innerHTML.includes( "$" ) ) {
			el.innerHTML = el.innerHTML.replace( /\$/g, "₹" );
		}
	} );

	/* ── 2. Medical Report images — click to open in current tab ── */
	document.querySelectorAll( ".saving-life-report-img" ).forEach( function ( img ) {
		img.style.cursor = "pointer";
		img.addEventListener( "click", function () {
			window.location.href = img.src;
		} );
	} );

} );
